/* CHYRONYX — Cart Drawer via Shopify AJAX Cart API (replaces CartContext + CartSidebar) */
(function(){
  var veil = document.querySelector('.cart-veil');
  var side = document.querySelector('.cart-side');
  var closeBtn = document.querySelector('.cart-x');
  var itemsWrap = document.querySelector('.cart-items-wrap');
  var totRow = document.querySelector('.cart-tot-amt');
  var cartCt = document.querySelectorAll('.cart-ct');
  var checkoutBtn = document.querySelector('.cart-checkout-btn');
  var diwaliSaleHandles = ["pink-rush","rosewood-veil","dark-leaf","cherry-velvet","velvet-midnight","ignis","ethereal","pulse","isla","solace","seraphine","eragonn","rosaline"];

  function openCart(){ 
    if(veil) veil.classList.add('on'); 
    if(side) side.classList.add('on');
    document.body.style.overflow='hidden';
  }
  function closeCart(){ 
    if(veil) veil.classList.remove('on'); 
    if(side) side.classList.remove('on');
    document.body.style.overflow='';
  }

  if(veil) veil.addEventListener('click', closeCart);
  if(closeBtn) closeBtn.addEventListener('click', closeCart);

  // Expose globally for add-to-cart buttons
  window.ChyxCart = {
    open: openCart,
    close: closeCart,
    add: function(variantId, qty){
      fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({items:[{id: variantId, quantity: qty||1}]})
      })
      .then(function(r){ return r.json(); })
      .then(function(){ window.ChyxCart.refresh(); openCart(); })
      .catch(function(err){ console.error('Cart add error:', err); });
    },
    remove: function(lineKey){
      fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({id: lineKey, quantity: 0})
      })
      .then(function(r){ return r.json(); })
      .then(function(){ window.ChyxCart.refresh(); })
      .catch(function(err){ console.error('Cart remove error:', err); });
    },
    changeQty: function(lineKey, newQty){
      if(newQty < 1){ window.ChyxCart.remove(lineKey); return; }
      fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({id: lineKey, quantity: newQty})
      })
      .then(function(r){ return r.json(); })
      .then(function(){ window.ChyxCart.refresh(); })
      .catch(function(err){ console.error('Cart qty error:', err); });
    },
    refresh: function(){
      return fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){ window.ChyxCart.render(cart); })
      .catch(function(err){ console.error('Cart fetch error:', err); });
    },
    render: function(cart){
      // Update count badges
      cartCt.forEach(function(el){ el.textContent = cart.item_count; });
      // Update total
      if(totRow) totRow.textContent = '₹' + (cart.total_price/100).toLocaleString('en-IN');
      // Render items
      if(!itemsWrap) return;
      if(cart.items.length === 0){
        itemsWrap.innerHTML = '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;gap:14px"><p class="serif" style="font-size:var(--f-lg);color:var(--tx-m)">Your curation is empty</p><p style="font-size:var(--f-xs);color:var(--tx-f);letter-spacing:.12em">Acquire a fragrance to begin</p></div>';
        return;
      }
      var html = '';
      cart.items.forEach(function(item){
        html += '<div class="cart-item">';
        html += '<div style="width:72px;height:96px;flex-shrink:0;background:hsl(var(--surface));border:1px solid var(--b-sub);overflow:hidden"><img src="'+item.image+'" alt="'+item.title+'" style="width:100%;height:100%;object-fit:cover"></div>';
        html += '<div style="flex:1;min-width:0">';
        html += '<p class="cart-item-n serif">'+item.title+'</p>';
        var originalSaleLine = diwaliSaleHandles.indexOf(item.handle) !== -1 && item.price === 119900 ? 150000 * item.quantity : 0;
        html += '<p class="cart-item-pr">' + (originalSaleLine ? '<s style="font-size:.8em;color:var(--tx-m);margin-right:.4em;">₹'+(originalSaleLine/100).toLocaleString('en-IN')+'</s>' : '') + '<span>₹'+(item.final_line_price/100).toLocaleString('en-IN')+'</span></p>';
        html += '<div class="cart-item-actions">';
        html += '<div class="cart-qty-wrap">';
        html += '<button class="cart-qty-btn" onclick="ChyxCart.changeQty(\''+item.key+'\','+(item.quantity - 1)+')" aria-label="Decrease quantity">−</button>';
        html += '<span class="cart-qty-val">'+item.quantity+'</span>';
        html += '<button class="cart-qty-btn" onclick="ChyxCart.changeQty(\''+item.key+'\','+(item.quantity + 1)+')" aria-label="Increase quantity">+</button>';
        html += '</div>';
        html += '<span role="button" tabindex="0" onclick="ChyxCart.remove(\''+item.key+'\')" class="cart-remove-btn">Remove</span>';
        html += '</div>';
        html += '</div></div>';
      });
      var eligible = cart.items.reduce(function(n,item){return n + (diwaliSaleHandles.indexOf(item.handle)!==-1 ? item.quantity : 0);},0);
      if(eligible % 2 === 1){html += '<div class="chx-cart-pair-offer"><p class="cart-pair-eyebrow">MAKE IT A PAIR</p><h3>Add one more.<br>Save ₹400.</h3><p>Any two 50 ml fragrances for ₹1,998.<br>Applied automatically to your pair.</p><button type="button" data-cart-pair-open>Choose another fragrance ＋</button></div>';}
      itemsWrap.innerHTML = html;
    }
  };

  // Cart open buttons
  document.querySelectorAll('[data-cart-open]').forEach(function(btn){
    btn.addEventListener('click', function(e){ e.preventDefault(); openCart(); });
  });

  // Initial load
  window.ChyxCart.refresh();
})();

